// ** react imports
import React, { useEffect } from 'react';

// ** router imports
import { useParams } from 'react-router-dom';

// ** custom hook imports
import { useGetTaxFileByCustomerId } from '../../../../hooks/apis/useTaxFile';

// ** component imports
import TaxFileCard from '../TaxFileCard';
import Loading from '../../../../components/common/Loading';

const CustomerTaxFiles = () => {
  // hooks
  const { id } = useParams();

  // custom hooks
  const { data, isGetTaxFileByCustomerIdLoading, getTaxFileByCustomerId } =
    useGetTaxFileByCustomerId();

  // effects
  useEffect(() => {
    if (id) {
      getTaxFileByCustomerId(id);
    }
  }, [id]);

  return (
    <div className="w-full h-[calc(75vh)] overflow-x-auto">
      <div className="sticky top-0 before:absolute before:inset-0 before:backdrop-blur-md max-lg:before:bg-white/90 dark:max-lg:before:bg-gray-800/90 before:-z-10 z-30 p-4 border-b border-gray-200 dark:border-gray-600/60">
        <h1 className="text-while dark:text-gray-100 font-bold text-xl">
          All Files
        </h1>
      </div>

      <div className="bg-white dark:bg-gray-800 shadow-xs rounded-xl relative">
        {!data?.data && data.data?.length === 0 && (
          <div className="w-full h-full">
            <div className="bg-white h-[calc(75vh)] dark:bg-gray-800 shadow-xs rounded-xl relative overflow-y-auto flex flex-col items-center justify-center gap-4">
              <p className="text-gray-600 dark:text-gray-300 inline-flex items-center-safe">
                <svg
                  className="shrink-0 fill-current mr-2 text-gray-400 dark:text-gray-500"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M11 7H13V17H11V7ZM15 11H17V17H15V11ZM7 13H9V17H7V13ZM15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"></path>
                  </svg>
                </svg>
                No tax files found
              </p>
            </div>
          </div>
        )}

        {isGetTaxFileByCustomerIdLoading && (
          <div className="absolute inset-0 bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm z-40 flex items-center justify-center rounded-xl">
            <div className="flex items-center gap-3 text-gray-600 dark:text-gray-300">
              <Loading />
            </div>
          </div>
        )}

        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
          {data?.data?.map(taxFile => (
            <div key={taxFile.id} className="grid-cols-1 md:grid-cols-2">
              <TaxFileCard taxFile={taxFile} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CustomerTaxFiles;
